const moment = require("moment");

const { HeaderPositionType, TrayType, PaletteColorType, NodeType, DEFAULT_ADDRESS } = require("../../../constants");
const { getDefaultChartModel } = require("./chartUtils");
const { uuid } = require("../../../utils/uuid");

const templates = [];

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// STRUCTURAL TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
templates.push({
    getInstanceProps: () => ({
        elementType: "PPTSlide",

        allowLayouts: false,
        allowHeader: false,
        allowFooter: false,
        allowElementCaption: false,
        allowElementAttribution: false,
        allowElementTextInline: false,
        allowElementTextTray: false,

        allowTheming: false,

        allowAnimations: false,

        allowCallouts: false,

        availableTrayLayouts: [],

        allowColorBackgrounds: false,
        allowColorful: false,

        canConvertToAuthoring: false,

        canSwitchTemplate: false,

        canMigrate: false,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE
            },
            primary: {
            }
        }
    }), getStaticProps: () => ({
        id: "ppt-slide",
        icon: "authoring",
        title: "PowerPoint Slide",
        description: "",
        category: "basic",
        tags: "",
        hideTemplate: true
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "AuthoringCanvas",

        allowHeader: false,
        allowFooter: false,
        allowElementCaption: false,
        allowElementAttribution: false,
        allowElementTextInline: false,
        allowElementTextTray: false,

        allowCallouts: false,

        availableTrayLayouts: [],

        allowColorBackgrounds: true,
        allowColorful: false,

        canConvertToAuthoring: false,

        canSwitchTemplate: false,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE
            },
            primary: {
            }
        }
    }), getStaticProps: () => ({
        id: "authoring",
        icon: "authoring",
        title: "Classic",
        description: "Start from scratch with a blank slide.",
        category: "basic popular",
        tags: "blank empty white canvas scratch",
        hideTemplate: false
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "BigNumbers",

        defaultData: {
            layout: {
                slideColor: "neutral",
                backgroundColor: "background_accent",
                backgroundStyle: "backgroundAccent"
            },
            primary: {
                items: [{
                    showLabel: true,
                    showChangeInValue: true,
                    showDescription: false,
                    value: {
                        text: "500",
                    },
                    label: {
                        text: "My Statistic"
                    },
                    changeLabel: {
                        text: "100%",
                    },
                    positive: true
                }]
            }
        }
    }), getStaticProps: () => ({
        id: "big-numbers",
        icon: "big_number",
        title: "Big Number",
        description: "Highlight your company metrics and impressive stats in a flexible grid.",
        category: "data",
        tags: "statistics big number value stat change amount data dashboard analytics report dollar arr mrr",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PresentationTitle",

        // variations: "title",

        allowHeader: false,
        allowFooter: false,
        allowElementCaption: false,
        allowElementAttribution: false,
        allowElementTextInline: false,
        allowElementTextTray: false,

        availableTrayLayouts: [],

        defaultData: {
            primary: {
                title: "",
                body: "",
                label: "",
                showFooter: false,
                showLabel: false
            }
        },

        allowColorful: false
    }), getStaticProps: () => ({
        id: "title",
        icon: "title",
        title: "Title",
        description: "Set the stage for what's to come with a title, date, and presenter names",
        category: "organization",
        tags: "title introduction introduce speaker speakers presenter presenters intros"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Agenda",
        headerPosition: HeaderPositionType.TOP,

        allowElementTitle: false,
        allowElementCaption: false,
        allowElementAttribution: false,

        allowColorful: true,

        defaultData: {
            "primary": {
                "showIndex": true,
                "items": [
                    {
                        "title": "",
                        "type": "item",
                        "content_value": ""
                    },
                    {
                        "title": "",
                        "type": "item",
                        "content_value": ""
                    },
                    {
                        "title": "",
                        "type": "item",
                        "content_value": ""
                    },
                    {
                        "title": "",
                        "type": "item",
                        "content_value": ""
                    },
                    {
                        "title": "",
                        "type": "item",
                        "content_value": ""
                    }
                ]
            }
        }

    }), getStaticProps: () => ({
        id: "agenda",
        icon: "agenda",
        title: "Agenda",
        description: "Prepare your audience for the structure of your presentation",
        category: "organization",
        tags: "q&A question answer segue transition agenda schedule steps objective goal OKR table contents"
    })
});

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// TEXT TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "TextSlide",
        allowColorful: false,
        defaultData: {
            primary: {
                text: {
                    text: ""
                }
            }
        }
    }), getStaticProps: () => ({
        id: "text",
        icon: "text",
        title: "Text",
        description: "There's a time and place for lengthy paragraphs. Be sure not to overwhelm your audience with information!",
        category: "basic",
        tags: "disclaimer text paragraph"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "TextList",

        variations: "list",

        defaultImageTrayType: TrayType.RIGHT_TRAY,
        allowColorful: true,
        defaultData: {
            "primary": {
                "items": [
                    {
                        "content_type": "icon",
                        "title": "",
                        "body": "",
                        "content_value": ""
                    }
                ],
                "listStyle": "bullets"
            }
        }

    }), getStaticProps: () => ({
        id: "textlist",
        icon: "textgrid_bullets",
        title: "Bullet Points",
        description: "Get the main point across with a concise list of headlines",
        category: "basic popular",
        tags: "bullet update status points text message messages values share our vision feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions summary summarize accomplish accomplishments accomplished make a list services solution key takeaway highlight priority case study product features"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "TextBoxGrid",

        variations: "list",
        // availableHeaderPositions: [HeaderPositionType.TOP],

        defaultData: {
            "primary": {
                "forceSingleColumn": false,
                "items": [
                    {
                        "content_type": "icon",
                        "title": "",
                        "body": ""
                    },
                    {
                        "title": "",
                        "body": "",
                        "content_type": "icon"
                    },
                    {
                        "title": "",
                        "body": "",
                        "content_type": "icon"
                    },
                    {
                        "title": "",
                        "body": "",
                        "content_type": "icon"
                    }
                ],
                "showIcons": true,
                "flipOrientation": false
            }
        },

        allowColorful: true,

    }), getStaticProps: () => ({
        id: "textBoxGrid",
        icon: "textBoxGrid",
        title: "Text Boxes",
        description: "Display your list items in compartments to create visual separation",
        category: "popular basic",
        tags: "objectives goals forces bullet update status points text message messages values share our vision feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions summary summarize accomplish accomplishments accomplished make a list services solution key takeaway highlight priority case study product features strategy strategic strategies persona solution service list"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "IconTextGrid",

        defaultData: {
            "primary": {
                "forceSingleColumn": false,
                "items": [
                    {
                        "content_type": "icon",
                        "title": "",
                        "body": "",
                        "content_value": ""
                    },
                    {
                        "content_type": "icon",
                        "title": "",
                        "body": "",
                        "content_value": ""
                    },
                    {
                        "content_type": "icon",
                        "title": "",
                        "body": "",
                        "content_value": ""
                    }
                ]
            }
        },

        variations: "list",
        allowColorful: true,

    }), getStaticProps: () => ({
        id: "textgrid_vertical_icons",
        icon: "textgrid_vertical_icons",
        title: "Icons with Text",
        description: "Decorate each of your points with an icon that adds visual emphasis.",
        category: "basic popular",
        tags: "customers problem icons text compete competitors competitor competition messages message make a list items category categories reasons values share our vision feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions summary summarize accomplish accomplishments accomplished services solution key takeaway highlight priority bullet update status points case study landscape product features call to action results business objective goal OKR price pricing"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "ImageCarousel",

        variations: "list",

        canConvertToAuthoring: true,

        allowColorful: true,
        defaultData: {
            "primary": {
                items: [{ id: uuid() }],
            }
        }

    }), getStaticProps: () => ({
        id: "textgrid_carousel",
        icon: "textgrid_carousel",
        title: "Message Carousel",
        description: "Create a relationship between sequential messages with this flip-through carousel.",
        category: "basic",
        tags: "persona procedure schedule big problem objective goal OKR carousel process message messages steps idea build values share our vision feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions summary summarize accomplish accomplishments accomplished make a list photo photos photographs images pictures services solution key takeaway highlight priority bullet update status points photos text"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoTextList",
        defaultData: {
            primary: {
                items: [{
                    title: ""
                }, {
                    title: ""
                }, {
                    title: ""
                }]
            }
        },

        variations: "list",

        availableTrayLayouts: [],

        allowColorful: true,
    }), getStaticProps: () => ({
        id: "textgrid_photos",
        icon: "textgrid_photos",
        title: "Photos with Text",
        description: "Use visuals to bring your main points to life.",
        category: "basic",
        tags: "persona partners partnerships pr press customers problem speaker intros team culture members teammates objective goal OKR screenshot shot screen compete competitors competitor competition messages message make a list items category categories reasons values share our vision feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions summary summarize accomplish accomplishments accomplished photo photos photographs images pictures services solution key takeaway highlight priority bullet update status points case study landscape call to action image text product features"
    })
});

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// PhotoCollage TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoCollage",

        allowHeader: true,
        availableTrayLayouts: [],

        allowElementAttribution: false,

        allowFooter: true,
        preventDefaultFooter: true,
        allowColorful: true,
        allowColorBackgrounds: false,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE
            },
            primary: {
                showGutter: false,
                fullBleed: true,
                matchTextScale: true,
                items: [{ id: uuid() }],
            }
        }
    }), getStaticProps: () => ({
        id: "image",
        icon: "image",
        title: "Image",
        description: "Grab your audience's attention with a big image. You can easily add a quote or text caption.",
        category: "impact basic",
        tags: "logo team picture image photo photos photographs images pictures emotional inspire audience inspiration emotion impact feelings"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoCollage",

        allowHeader: true,
        allowElementAttribution: true,
        allowFooter: true,
        preventDefaultFooter: true,

        availableHeaderPositions: [HeaderPositionType.TOP, HeaderPositionType.LEFT],

        availableTrayLayouts: [],

        allowColorful: true,
        allowColorBackgrounds: false,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE
            },
            primary: {
                showHeadline: false,
                showImages: true,
                layoutType: "grid",
                aspectRatio: "fill",
                showGutter: true,
                fullBleed: true,
                matchTextScale: true,
                items: [{ id: uuid() }, { id: uuid() }, { id: uuid() }, { id: uuid() }],
                cols: 4,
                rows: 2
            }
        }

    }), getStaticProps: () => ({
        id: "collage",
        icon: "collage",
        title: "Photo Grid",
        description: "Create a variety of layouts with text, photos, and icons in this responsive grid.",
        category: "basic impact popular",
        tags: "portfolio team problem accomplish accomplishments accomplished photo photos photographs image grid images pictures emotional inspire audience inspiration emotion impact feelings product screenshots screen shots"
    })
});

// -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
// Headline templates
// -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

// region OldImageGridTemplates
// these are the previous imageGrid templates that have been replaced with headline templates
// we need to keep the previous templates so that slides created prior to the layout refactor of Oct 2018 are consistent
// but they are hidden from the AddSlide dialog

// endregion

// new headline templates

templates.push({
    getInstanceProps: () => ({
        elementType: "Headline",

        availableTrayLayouts: [],

        allowFooter: true,
        allowHeader: false,
        allowElementTextInline: true,
        allowElementTextTray: true,
        allowElementAttribution: true,

        defaultData: {
            primary: {
                blocks: [{
                    type: "headline"
                }],
                items: [],
                layoutType: "grid",
                fullBleed: true,
                showGutter: true
            }
        },
    }), getStaticProps: () => ({
        id: "headline2",
        icon: "headline",
        title: "Headline",
        description: "Emphasize your point with large text. Add images to make it more visual.",
        category: "impact popular",
        tags: "thank big segue transition share our mission provocative question call to action vision differentiate differentiator proposition propositions powerful bold summary summarize message statement accomplish accomplishments accomplished photo photos photographs images pictures emotional inspire audience inspiration emotion impact feelings key takeaway highlight big headline and culture text"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Headline",

        availableTrayLayouts: [],

        allowFooter: true,
        preventDefaultFooter: true,
        allowHeader: false,
        allowElementTextInline: true,
        allowElementTextTray: true,
        allowElementAttribution: true,

        defaultData: {
            primary: {
                blocks: [
                    {
                        type: "label",
                        content: {
                            text: "Section 1",
                            styles: [
                                {
                                    start: 0,
                                    end: 9
                                }
                            ]
                        }
                    },
                    {
                        type: "headline"
                    }
                ],
                items: [],
                layoutType: "grid",
                fullBleed: true,
                showGutter: true
            },
            layout: {
                backgroundColor: "theme",
                backgroundStyle: "backgroundColor"
            }
        },

        version: 2,
    }), getStaticProps: () => ({
        id: "section",
        icon: "section_break",
        title: "Section Break",
        description: "Leverage section breaks for transitional ideas, questions, and physical relief during long presentations.",
        category: "organization",
        tags: "question introduction introduce chapter section transition segue transition header"

    })
});

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// MISC TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "WordCloudElement",

        allowElementAttribution: false,

        allowColorful: true,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE,
            },
            primary: {
                style: "right_angles",
                sort: "size",
                scale: 25,
                calculatedWidth: 1180,
                calculatedHeight: 620,
                version: 2,
                wordcloud: "[{\"word\":\"magic\",\"weight\":\"1\",\"layout\":{\"x\":1486,\"y\":790,\"rotation\":0,\"offsetX\":-23.912490844726562,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"designer\",\"weight\":\"1\",\"layout\":{\"x\":1054,\"y\":874,\"rotation\":0,\"offsetX\":-36.58747863769531,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"software\",\"weight\":\"1\",\"layout\":{\"x\":1402,\"y\":842,\"rotation\":0,\"offsetX\":-39.937469482421875,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"easy\",\"weight\":\"1\",\"layout\":{\"x\":866,\"y\":778,\"rotation\":0,\"offsetX\":-19.22498321533203,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"automatic\",\"weight\":\"1\",\"layout\":{\"x\":792,\"y\":540,\"rotation\":90,\"offsetX\":-42.48747253417969,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"themes\",\"weight\":\"1\",\"layout\":{\"x\":1056,\"y\":366,\"rotation\":0,\"offsetX\":-30.42498016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"template\",\"weight\":\"1\",\"layout\":{\"x\":1312,\"y\":366,\"rotation\":0,\"offsetX\":-38.42497253417969,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"web\",\"weight\":\"1\",\"layout\":{\"x\":1414,\"y\":426,\"rotation\":0,\"offsetX\":-16.712493896484375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"timeline\",\"weight\":\"1\",\"layout\":{\"x\":1556,\"y\":526,\"rotation\":0,\"offsetX\":-34.73748016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"wordcloud\",\"weight\":\"1\",\"layout\":{\"x\":1332,\"y\":862,\"rotation\":0,\"offsetX\":-46.199974060058594,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"chart\",\"weight\":\"1\",\"layout\":{\"x\":1346,\"y\":386,\"rotation\":0,\"offsetX\":-24.7249755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"product\",\"weight\":\"1\",\"layout\":{\"x\":796,\"y\":696,\"rotation\":90,\"offsetX\":-34.0374755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"icons\",\"weight\":\"1\",\"layout\":{\"x\":1492,\"y\":766,\"rotation\":0,\"offsetX\":-22.16248321533203,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"images\",\"weight\":\"1\",\"layout\":{\"x\":1234,\"y\":870,\"rotation\":0,\"offsetX\":-28.36248779296875,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"pictures\",\"weight\":\"1\",\"layout\":{\"x\":1498,\"y\":466,\"rotation\":0,\"offsetX\":-35.637474060058594,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"filters\",\"weight\":\"1\",\"layout\":{\"x\":984,\"y\":838,\"rotation\":0,\"offsetX\":-29.0374755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"grid\",\"weight\":\"1\",\"layout\":{\"x\":874,\"y\":468,\"rotation\":-90,\"offsetX\":-17.37499237060547,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"diagram\",\"weight\":\"1\",\"layout\":{\"x\":1536,\"y\":728,\"rotation\":90,\"offsetX\":-34.29998016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"magic\",\"weight\":\"1\",\"layout\":{\"x\":1506,\"y\":486,\"rotation\":0,\"offsetX\":-23.912490844726562,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"designer\",\"weight\":\"1\",\"layout\":{\"x\":910,\"y\":434,\"rotation\":0,\"offsetX\":-36.58747863769531,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"software\",\"weight\":\"1\",\"layout\":{\"x\":1406,\"y\":822,\"rotation\":0,\"offsetX\":-39.937469482421875,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"easy\",\"weight\":\"1\",\"layout\":{\"x\":898,\"y\":790,\"rotation\":90,\"offsetX\":-19.22498321533203,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"automatic\",\"weight\":\"1\",\"layout\":{\"x\":1140,\"y\":870,\"rotation\":0,\"offsetX\":-42.48747253417969,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"themes\",\"weight\":\"1\",\"layout\":{\"x\":1566,\"y\":620,\"rotation\":-90,\"offsetX\":-30.42498016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"template\",\"weight\":\"1\",\"layout\":{\"x\":1128,\"y\":366,\"rotation\":0,\"offsetX\":-38.42497253417969,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"web\",\"weight\":\"1\",\"layout\":{\"x\":878,\"y\":758,\"rotation\":0,\"offsetX\":-16.712493896484375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"timeline\",\"weight\":\"1\",\"layout\":{\"x\":792,\"y\":620,\"rotation\":-90,\"offsetX\":-34.73748016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"wordcloud\",\"weight\":\"1\",\"layout\":{\"x\":1216,\"y\":366,\"rotation\":0,\"offsetX\":-46.199974060058594,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"chart\",\"weight\":\"1\",\"layout\":{\"x\":1294,\"y\":386,\"rotation\":0,\"offsetX\":-24.7249755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"product\",\"weight\":\"1\",\"layout\":{\"x\":1324,\"y\":842,\"rotation\":0,\"offsetX\":-34.0374755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"icons\",\"weight\":\"1\",\"layout\":{\"x\":1382,\"y\":412,\"rotation\":90,\"offsetX\":-22.16248321533203,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"images\",\"weight\":\"1\",\"layout\":{\"x\":1446,\"y\":446,\"rotation\":90,\"offsetX\":-28.36248779296875,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"pictures\",\"weight\":\"1\",\"layout\":{\"x\":978,\"y\":818,\"rotation\":0,\"offsetX\":-35.637474060058594,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"filters\",\"weight\":\"1\",\"layout\":{\"x\":1516,\"y\":642,\"rotation\":0,\"offsetX\":-29.0374755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"grid\",\"weight\":\"1\",\"layout\":{\"x\":1350,\"y\":532,\"rotation\":-90,\"offsetX\":-17.37499237060547,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"diagram\",\"weight\":\"1\",\"layout\":{\"x\":820,\"y\":700,\"rotation\":90,\"offsetX\":-34.29998016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"magic\",\"weight\":\"1\",\"layout\":{\"x\":1510,\"y\":718,\"rotation\":90,\"offsetX\":-23.912490844726562,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"designer\",\"weight\":\"1\",\"layout\":{\"x\":1518,\"y\":594,\"rotation\":0,\"offsetX\":-36.58747863769531,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"software\",\"weight\":\"1\",\"layout\":{\"x\":924,\"y\":802,\"rotation\":90,\"offsetX\":-39.937469482421875,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"easy\",\"weight\":\"1\",\"layout\":{\"x\":1258,\"y\":554,\"rotation\":90,\"offsetX\":-19.22498321533203,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"automatic\",\"weight\":\"1\",\"layout\":{\"x\":992,\"y\":426,\"rotation\":0,\"offsetX\":-42.48747253417969,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"themes\",\"weight\":\"1\",\"layout\":{\"x\":1490,\"y\":724,\"rotation\":-90,\"offsetX\":-30.42498016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"template\",\"weight\":\"1\",\"layout\":{\"x\":1324,\"y\":822,\"rotation\":0,\"offsetX\":-38.42497253417969,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"web\",\"weight\":\"1\",\"layout\":{\"x\":1310,\"y\":734,\"rotation\":0,\"offsetX\":-16.712493896484375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"timeline\",\"weight\":\"1\",\"layout\":{\"x\":988,\"y\":798,\"rotation\":0,\"offsetX\":-34.73748016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"wordcloud\",\"weight\":\"1\",\"layout\":{\"x\":844,\"y\":712,\"rotation\":90,\"offsetX\":-46.199974060058594,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"chart\",\"weight\":\"1\",\"layout\":{\"x\":1470,\"y\":718,\"rotation\":-90,\"offsetX\":-24.7249755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"product\",\"weight\":\"1\",\"layout\":{\"x\":1512,\"y\":618,\"rotation\":0,\"offsetX\":-34.0374755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"icons\",\"weight\":\"1\",\"layout\":{\"x\":1012,\"y\":446,\"rotation\":0,\"offsetX\":-22.16248321533203,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"images\",\"weight\":\"1\",\"layout\":{\"x\":1006,\"y\":466,\"rotation\":0,\"offsetX\":-28.36248779296875,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"pictures\",\"weight\":\"1\",\"layout\":{\"x\":1442,\"y\":486,\"rotation\":0,\"offsetX\":-35.637474060058594,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"filters\",\"weight\":\"1\",\"layout\":{\"x\":1372,\"y\":494,\"rotation\":0,\"offsetX\":-29.0374755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"grid\",\"weight\":\"1\",\"layout\":{\"x\":1272,\"y\":734,\"rotation\":0,\"offsetX\":-17.37499237060547,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"diagram\",\"weight\":\"1\",\"layout\":{\"x\":1128,\"y\":612,\"rotation\":-90,\"offsetX\":-34.29998016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"timeline\",\"weight\":\"2\",\"layout\":{\"x\":822,\"y\":536,\"rotation\":90,\"offsetX\":-69.4749755859375,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"wordcloud\",\"weight\":\"2\",\"layout\":{\"x\":1024,\"y\":396,\"rotation\":0,\"offsetX\":-92.39996337890625,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"chart\",\"weight\":\"2\",\"layout\":{\"x\":1320,\"y\":416,\"rotation\":0,\"offsetX\":-49.449974060058594,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"product\",\"weight\":\"2\",\"layout\":{\"x\":1396,\"y\":792,\"rotation\":0,\"offsetX\":-68.07496643066406,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"icons\",\"weight\":\"2\",\"layout\":{\"x\":876,\"y\":704,\"rotation\":-90,\"offsetX\":-44.324981689453125,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"images\",\"weight\":\"2\",\"layout\":{\"x\":864,\"y\":548,\"rotation\":-90,\"offsetX\":-56.72498321533203,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"pictures\",\"weight\":\"2\",\"layout\":{\"x\":1186,\"y\":396,\"rotation\":0,\"offsetX\":-71.27497100830078,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"filters\",\"weight\":\"2\",\"layout\":{\"x\":1462,\"y\":516,\"rotation\":0,\"offsetX\":-58.074981689453125,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"grid\",\"weight\":\"2\",\"layout\":{\"x\":1440,\"y\":726,\"rotation\":-90,\"offsetX\":-34.74999237060547,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"diagram\",\"weight\":\"2\",\"layout\":{\"x\":1496,\"y\":672,\"rotation\":0,\"offsetX\":-68.5999755859375,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"magic\",\"weight\":\"2\",\"layout\":{\"x\":916,\"y\":714,\"rotation\":-90,\"offsetX\":-47.824981689453125,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"designer\",\"weight\":\"2\",\"layout\":{\"x\":906,\"y\":532,\"rotation\":-90,\"offsetX\":-73.17498016357422,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"software\",\"weight\":\"2\",\"layout\":{\"x\":1486,\"y\":556,\"rotation\":0,\"offsetX\":-79.87496948242188,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"easy\",\"weight\":\"2\",\"layout\":{\"x\":1366,\"y\":752,\"rotation\":0,\"offsetX\":-38.449981689453125,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"automatic\",\"weight\":\"2\",\"layout\":{\"x\":1348,\"y\":456,\"rotation\":0,\"offsetX\":-84.97496032714844,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"themes\",\"weight\":\"2\",\"layout\":{\"x\":956,\"y\":728,\"rotation\":-90,\"offsetX\":-60.8499755859375,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"template\",\"weight\":\"2\",\"layout\":{\"x\":946,\"y\":524,\"rotation\":-90,\"offsetX\":-76.84996795654297,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"web\",\"weight\":\"2\",\"layout\":{\"x\":1384,\"y\":540,\"rotation\":-90,\"offsetX\":-33.42498779296875,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"colors\",\"weight\":\"3\",\"layout\":{\"x\":890,\"y\":634,\"rotation\":0,\"offsetX\":-85.98748016357422,\"offsetY\":7.5,\"fontSize\":75,\"weight\":\"3\"},\"drawn\":true},{\"word\":\"strategies\",\"weight\":\"3\",\"layout\":{\"x\":1150,\"y\":834,\"rotation\":0,\"offsetX\":-133.01246643066406,\"offsetY\":7.5,\"fontSize\":75,\"weight\":\"3\"},\"drawn\":true},{\"word\":\"diversity\",\"weight\":\"3\",\"layout\":{\"x\":1152,\"y\":446,\"rotation\":0,\"offsetX\":-115.7249755859375,\"offsetY\":7.5,\"fontSize\":75,\"weight\":\"3\"},\"drawn\":true},{\"word\":\"disruptive\",\"weight\":\"3\",\"layout\":{\"x\":1198,\"y\":774,\"rotation\":0,\"offsetX\":-129.93746948242188,\"offsetY\":7.5,\"fontSize\":75,\"weight\":\"3\"},\"drawn\":true},{\"word\":\"layout\",\"weight\":\"3\",\"layout\":{\"x\":1344,\"y\":698,\"rotation\":0,\"offsetX\":-83.54998016357422,\"offsetY\":7.5,\"fontSize\":75,\"weight\":\"3\"},\"drawn\":true},{\"word\":\"work\",\"weight\":\"4\",\"layout\":{\"x\":1394,\"y\":614,\"rotation\":0,\"offsetX\":-88.74998474121094,\"offsetY\":10,\"fontSize\":100,\"weight\":\"4\"},\"drawn\":true},{\"word\":\"smart\",\"weight\":\"4\",\"layout\":{\"x\":1156,\"y\":706,\"rotation\":0,\"offsetX\":-103.99998474121094,\"offsetY\":10,\"fontSize\":100,\"weight\":\"4\"},\"drawn\":true},{\"word\":\"simple\",\"weight\":\"4\",\"layout\":{\"x\":1014,\"y\":678,\"rotation\":-90,\"offsetX\":-109.44998168945312,\"offsetY\":10,\"fontSize\":100,\"weight\":\"4\"},\"drawn\":true},{\"word\":\"Beautiful\",\"weight\":\"5\",\"layout\":{\"x\":1162,\"y\":524,\"rotation\":0,\"offsetX\":-200.375,\"offsetY\":12.5,\"fontSize\":125,\"weight\":\"5\"},\"drawn\":true},{\"word\":\"Slides\",\"weight\":\"5\",\"layout\":{\"x\":1178,\"y\":620,\"rotation\":0,\"offsetX\":-128.3125,\"offsetY\":12.5,\"fontSize\":125,\"weight\":\"5\"},\"drawn\":true}]"
            }
        }

    }), getStaticProps: () => ({
        id: "wordCloud",
        icon: "word_cloud",
        title: "Word Cloud",
        description: "Highlight the main sentiment in a cluster of related words.",
        category: "impact",
        tags: "visual word cloud text survey results impact idea big findings concept map wordle"
    })
});

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// PRODUCT TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "ProductScreenshot",
        defaultData: {
            "primary": {
                "content_type": "image",
                "content_value": "",
                "showCallout": true,
                "listStyle": "bullets",
                "items": [
                    {
                        "content_type": "icon",
                        "title": "",
                        "body": "",
                        "calloutTargetX": 0.25,
                        "calloutTargetY": 0.25,
                        "content_value": ""
                    }
                ],
                "frameType": "apple_macbook_space_grey"
            }
        },

        availableTrayLayouts: [],
        allowColorful: true,

    }), getStaticProps: () => ({
        id: "product_laptop",
        icon: "product_laptop",
        title: "Product Screenshot",
        description: "Illustrate feature capabilities, design, and UX across just about any device.",
        category: "product",
        tags: "display product laptop desktop screenshot callouts features monitor screen shots pc device callout features mobile phone iphone android device mac feature features benefit benefits annotation differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions photo photos photographs images pictures demo"
    })
});

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// DIAGRAM TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "VennDiagram",

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            "primary": {
                "items": [
                    {
                        x: 0,
                        y: -100,
                        radius: 150,
                        color: PaletteColorType.ACCENT1,
                        label: ""
                    },
                    {
                        x: -100,
                        y: 100,
                        radius: 150,
                        color: PaletteColorType.ACCENT2,
                        label: ""
                    },
                    {
                        x: 100,
                        y: 100,
                        radius: 150,
                        color: PaletteColorType.ACCENT3,
                        label: ""
                    }
                ]
            }
        },

    }), getStaticProps: () => ({
        id: "vennDiagram",
        icon: "venn_diagram",
        title: "Venn Diagram",
        description: "Show how multiple ideas vary in size and overlap.",
        category: "comparisons",
        tags: "competitive landscape quadrant xy plot chart share hierarchy set relationship market compare groups us vs them advantages comparison overlap competition competitor relative more less same better worse big small attributes qualities circles bubbles factors"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "XYGraph",

        variations: "xygraph",

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            primary: {
                yAxisLabel: "Ability to Execute",
                xAxisLabel: "Completeness of Vision",
                showArrowHeads: true,
                showAxis: true,
                axisPosition: "left",
                showAxisLabels: true,
                showGrid: true,
                gridSize: 34,
                showQuadrants: false,
                showQuadrantLabels: false,
                label1: "Challengers",
                label2: "Leaders",
                label3: "Niche Players",
                label4: "Visionaries",
                items: [{
                    x: 0.5,
                    y: 0.5,
                    size: 150,
                    color: PaletteColorType.THEME,
                    nodeType: NodeType.CIRCLE
                }]
            }
        }
    }), getStaticProps: () => ({
        id: "xygraph",
        icon: "xy_axis",
        title: "XY Plot",
        description: "Communicate relationships, patterns, and priorities of items plotted against two key metrics.",
        category: "comparisons",
        tags: "persona competitive landscape venn quadrant share pro con size group circles bubbles hierarchy set plot scatter scatterplot dimension axis axes cluster relationship market compare groups us vs them advantanges comparison competition competitor relative more less same better worse big small attributes qualities scattergram"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "SwotDiagram",
        availableHeaderPositions: [HeaderPositionType.TOP],

        availableTrayLayouts: [],

        defaultData: {
            "primary": {
                "showCellTitle": true,
                "showCellChar": true,
                "showAxisLabel": false,
                "items": [
                    {
                        "title": "Strengths"
                    },
                    {
                        "title": "Weaknesses"
                    },
                    {
                        "title": "Opportunities"
                    },
                    {
                        "title": "Threats"
                    }
                ]
            }
        },

        allowColorful: true,

    }), getStaticProps: () => ({
        id: "swot_diagram",
        icon: "swot_diagram",
        title: "SWOT Analysis",
        category: "comparisons",
        description: "Highlight key results of a SWOT assessment.",
        tags: "strength weakness opportunity threat advantage disadvantage difference differentiate differentiator factors internal external strategy strategic plan planning"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Thermometer",
        defaultData: {
            primary: {
                showBulb: true,
                value: 50,
                tickCount: 5,
                targetMax: 100,
                valuePosition: "fluidTop"
            }
        }
    }), getStaticProps: () => ({
        id: "thermometer",
        category: "data",
        title: "Thermometer",
        tags: "thermometer",
        icon: "thermometer",
        description: "Show progress toward a single goal with this dynamic, animated thermometer."
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Countdown",

        defaultData: {
            primary: {
                date: moment().startOf("day").add(10, "days").format("M/D/YYYY"),
                time: "5:00 PM",
                showSeconds: true
            }
        },

        allowHeader: true,
        allowFooter: true,
        allowColorful: true,
    }), getStaticProps: () => ({
        hideTemplate: false,
        id: "countdown",
        icon: "countdown",
        title: "Countdown",
        description: "Build anticipation leading up to a launch or deadline with an animated Countdown slide.",
        category: "impact",
        tags: "date future time count countdown timer",
        isNew: true
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Timer",

        defaultData: {
            primary: {
                duration: 5 * 60, // default to 5 minutes
                emphasize: 60
            }
        },

        allowHeader: true,
        allowFooter: true,
        allowColorful: true,
    }), getStaticProps: () => ({
        hideTemplate: false,
        id: "timer",
        icon: "timer",
        title: "Timer",
        description: "This animated timer is perfect for shorter periods of time, like a coffee break or Q+A session.",
        category: "impact",
        tags: "date future time count countdown timer",
        isNew: true
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "ArrowBars",

        availableTrayLayouts: [TrayType.RIGHT_TRAY, TrayType.RIGHT_INLINE],
        availableHeaderPositions: [HeaderPositionType.TOP],

        defaultData: {
            primary: {
                showIndex: true,
                showFoldEffect: true,
                items: [
                    {
                        value: 33,
                        showArrowHead: true,
                        label: ""
                    },
                    {
                        value: 50,
                        showArrowHead: true,
                        label: ""
                    },
                    {
                        value: 75,
                        showArrowHead: true,
                        label: ""
                    }
                ]
            }
        },

        allowColorful: true,

    }), getStaticProps: () => ({
        id: "arrow_bars",
        icon: "arrow_bars",
        title: "Arrow Bars",
        description: "Depict hierarchy and sequence by adjusting items' vertical and horizontal rank and space.",
        category: "comparisons popular",
        tags: "progress relative initiative initiatives compete competitors competitor competition grow growing growth data shrink shrinking shrink bigger big large larger small smaller faster slower fast slow grew shrunk change changed changing grown feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions better worse faster slower more less higher lower make a head-to-head comparison relationship landscape infographic"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "RadialBarChart",

        defaultData: {
            primary: {
                trackStyle: "bar",
                showGrid: false,
                maxValue: 100,
                startPosition: "top",
                items: [
                    {
                        value: 33,
                        label: ""
                    },
                    {
                        value: 50,
                        label: ""
                    },
                    {
                        value: 75,
                        label: ""
                    }
                ]
            }
        },

        allowColorful: true,

    }), getStaticProps: () => ({
        id: "radial_bar_chart",
        icon: "radial_bar_chart",
        title: "Radial Bar Chart",
        description: "Compare progress or outcomes across items with a shared objective.",
        category: "comparisons",
        tags: "bar chart polar circular circle compare comparison radial percentage coordinate visual concentric"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Pyramid",

        availableHeaderPositions: [HeaderPositionType.TOP],

        variations: "pyramid",

        defaultData: {
            "primary": {
                "inverted": false,
                "color": "accent1",
                "showDescription": true,
                capSize: 0,
                baseSize: 60,
                step: false,
                capAlign: "center",
                shadeColors: true,
                "items": [
                    {
                        "title": "Step 1",
                        "body": ""
                    },
                    {
                        "title": "Step 2",
                        "body": ""
                    },
                    {
                        "title": "Step 3",
                        "body": ""
                    }
                ]
            }
        },

        allowColorful: true,

    }), getStaticProps: () => ({
        id: "pyramid",
        icon: "pyramid",
        title: "Pyramid",
        description: "Show hierarchy by size, quantity, or priority with this flexible, customizable graphic.",
        category: "diagram",
        tags: "pipeline price pricing market size pyramid hierarchy diagram message messages compete competitors competitor competition shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown values feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions percent percentage landscape org structure"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Pyramid",

        availableHeaderPositions: [HeaderPositionType.TOP],
        variations: "pyramid",

        allowColorful: true,

        defaultData: {
            "primary": {
                showDescription: true,
                capSize: 65,
                baseSize: 15,
                step: false,
                inverted: false,
                capAlign: "center",
                shadeColors: true,
                "items": [
                    {
                        "title": "Step 1",
                        "body": ""
                    },
                    {
                        "title": "Step 2",
                        "body": ""
                    },
                    {
                        "title": "Step 3",
                        "body": ""
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "funnel",
        icon: "funnel",
        title: "Funnel",
        description: "Illustrate dropoff between steps in a flow.",
        category: "diagram",
        tags: "procedure schedule pipeline traction marketing market funnel process filter percent percentage progress move movement churn retention step"
    })
});

// const visual_big_stat = createTemplate({
//     elementType: "CompareGrid",
//     showHeader: true,
//
//     defaultData: {
//         items: [
//             {
//                 value: 25,
//             },
//             {
//                 value: 50,
//             }
//         ]
//     },
//
// }, {
//     id: "visual_big_stat",
//     icon: "visual_big_stat",
//     variations: "radial",
//     title: "Visual Stat",
//     description: "Highlight a single statistic visually and punctuate it with an image.",
//     category: "data",
//     tags: "case study compare column pie chart donut chart goal OKR chart compare vs infographic change compete competitors competitor competition grow growing data shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown survey poll results business percent percentage progress better worse faster slower more less higher lower metrics performance business performance business over time churn retention make a head-to-head comparison relationship market share stat statistic growth projections categories"
// }});

templates.push({
    getInstanceProps: () => ({
        elementType: "Target",

        // variations: "target",

        defaultData: {
            layout: {
                slideColor: "colorful"
            },
            primary: {
                innerRadius: 0,
                items: [
                    {
                        segments: [{
                            color: "auto"
                        }],
                    }, {
                        segments: [{
                            color: "auto"
                        }],
                    }, {
                        segments: [{
                            color: "auto"
                        }],
                    }
                ]
            }
        },

        allowColorBackgrounds: false,

    }), getStaticProps: () => ({
        id: "target",
        icon: "target_chart",
        title: "Target",
        description: "Illustrate how elements radiate from or build upon a core concept or goal.",
        category: "diagram",
        tags: "progress categories goal result head-to-head comparison relationship target circle concentric segment inner arrow relationship "
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PictorialCharts",
        showHeader: false,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE,
            },
            primary: {
                fitIcons: true,
                items: [
                    {
                        value: 75,
                        shape: "male",
                        description: ""
                    }
                ]
            }
        },

        allowColorful: true,
    }), getStaticProps: () => ({
        id: "visual_percentage",
        icon: "visual_percentage",
        title: "Percentage with Icons",
        description: "Use this infographic slide to highlight progress metrics with contextual iconography.",
        category: "data",
        tags: "case study column pie chart donut chart big stat problem growth percent percentage survey poll results business churn retention data icon stat statistic infographic pictograph"
    })
});

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// CHART TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "Dashboard",

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            primary: {
                items: [
                    {
                        elementType: "chart",
                        chart: getDefaultChartModel("line")
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "chart_line",
        icon: "chart_line",
        title: "Line Chart",
        description: "Graph trends over time. Emphasize key changes and call out important data.",
        category: "data popular",
        tags: "column traction data chart growth projections data series line time trend compete competitors competitor competition grew shrunk change changed changing grown revenue metrics performance business profit sales income volume expenses costs progress better worse faster slower more less higher lower amount total sum number time over churn retention compare vs comparison relationship financial model"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Dashboard",

        // variations: "chart",

        defaultImageTrayType: TrayType.RIGHT_TRAY,

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            primary: {
                items: [
                    {
                        elementType: "chart",
                        chart: getDefaultChartModel("column")
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "chart_column",
        icon: "chart_column",
        title: "Column Chart",
        description: "Compare categories, track changes over time, or show parts of a whole.",
        category: "data",
        tags: "line pie chart donut chart burn traction market share bar chart time trend compete competitors competitor competition grow growing growth projections data shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown survey poll results percent percentage revenue metrics performance profit sales income volume expenses costs progress better worse faster slower better worse faster slower more less higher lower amount total sum part number share over time by category churn retention financial model compare comparison relationship"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Dashboard",

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            "primary": {
                "items": [
                    {
                        "elementType": "chart",
                        "chart": {
                            "showLegend": false,
                            "showXAxis": true,
                            "showYAxis": false,
                            "showAxisLabels": false,
                            "showXGridLines": true,
                            "showYGridLines": true,
                            "groupData": false,
                            "chartData": {
                                "series": [
                                    {
                                        "id": "series1",
                                        "name": "Data",
                                        "type": "waterfall",
                                        "data": [
                                            {
                                                "y": 1420000,
                                            },
                                            {
                                                "y": 1200000,
                                            },
                                            {
                                                "y": 250000,
                                            },
                                            {
                                                "y": -340000,
                                            },
                                            {
                                                "y": "sum",
                                            },
                                            {
                                                "y": -275000,
                                            },
                                            {
                                                "y": -310000,
                                            },
                                            {
                                                "y": "sum",
                                            },
                                            {
                                                "y": -550000,
                                            },
                                            {
                                                "y": "sum",
                                            }
                                        ],
                                        "colorName": "chart1",
                                        "greenRed": false,
                                        "showDataLabels": true
                                    }
                                ],
                                "xAxis": {
                                    "visible": true,
                                    "showFirstLabel": true,
                                    "showLastLabel": true,
                                    "endOnTick": true,
                                    "categories": [
                                        "Beginning Cash",
                                        "Product Revenue",
                                        "Services Revenue",
                                        "Revenue Adjustments",
                                        "Net Revenue",
                                        "Fixed Costs",
                                        "R&D",
                                        "Gross Income",
                                        "Taxes",
                                        "Net Income"
                                    ],
                                    "showAxisLine": true,
                                    "showGridLines": false,
                                    "showMajorTicks": false,
                                    "showMinorTicks": false,
                                    "axisTitle": false,
                                    "axisTitleText": "Title",
                                    "labelInterval": 1,
                                    "type": "linear",
                                    "autoType": "linear",
                                    "categoryType": "auto",
                                    "labels": {
                                        "enabled": true
                                    }
                                },
                                "yAxis": {
                                    "visible": true,
                                    "showFirstLabel": true,
                                    "showLastLabel": true,
                                    "endOnTick": true,
                                    "showAxisLine": false,
                                    "showGridLines": true,
                                    "showMajorTicks": false,
                                    "showMinorTicks": false,
                                    "labelAbbreviation": false,
                                    "labelCurrency": "none",
                                    "labelFormat": "ones",
                                    "axisTitle": "none",
                                    "axisTitleText": "Title",
                                    "labels": {
                                        "enabled": false
                                    },
                                    format: "currency",
                                    formatOptions: {
                                        abbreviated: "lower",
                                        currency: "$",
                                        decimal: 0,
                                        accountingStyle: false,
                                        separator: true
                                    }
                                },
                                "yAxis2": {
                                    "visible": false,
                                    "opposite": true,
                                    "showFirstLabel": true,
                                    "showLastLabel": true,
                                    "endOnTick": true,
                                    "showAxisLine": true,
                                    "showGridLines": false,
                                    "showMajorTicks": false,
                                    "showMinorTicks": false,
                                    "labelAbbreviation": false,
                                    "labelCurrency": "none",
                                    "labelFormat": "ones",
                                    "axisTitle": "none",
                                    "axisTitleText": "Title",
                                    "labels": {
                                        "enabled": true
                                    }
                                },
                                "legend": {
                                    "enabled": false
                                }
                            },
                            "legendPosition": "off"
                        }
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "chart_waterfall",
        icon: "chart_waterfall",
        title: "Waterfall Chart",
        description: "Communicate the cumulative effect of sequentially introduced positive or negative values.",
        category: "data",
        tags: "waterfall line pie chart donut chart burn traction market share bar chart time trend compete competitors competitor competition grow growing growth projections data shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown survey poll results percent percentage revenue metrics performance profit sales income volume expenses costs progress better worse faster slower better worse faster slower more less higher lower amount total sum part number share over time by category churn retention financial model compare comparison relationship"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Dashboard",

        defaultImageTrayType: TrayType.RIGHT_TRAY,

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            primary: {
                items: [
                    {
                        elementType: "chart",
                        chart: getDefaultChartModel("area")
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "chart_area",
        icon: "chart_area",
        title: "Area Chart",
        description: "Show a volume change over time and emphasize key moments.",
        category: "data",
        tags: "column burn traction financial chart compete competitors competitor competition grow growing growth projections data shrink shrinking shrink bigger big large larger small smaller revenue metrics performance business profit sales income volume expenses costs progress amount total sum number time over churn retention trend stacked"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Dashboard",

        // variations: "chart",

        defaultImageTrayType: TrayType.RIGHT_TRAY,

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            "primary": {
                "items": [
                    {
                        "elementType": "piechart",
                        "piechart": {
                            "startRadius": 0,
                            "innerRadius": 0,
                            "isDonut": false,
                            "labelFormat": "percentage",
                            "sortValues": true,
                            "data": [
                                {
                                    "value": 3,
                                    "label": {
                                        "text": "Apple"
                                    },
                                    "color": "auto",
                                    "offset": 0
                                },
                                {
                                    "value": 2,
                                    "label": {
                                        "text": "Pear"
                                    },
                                    "color": "auto",
                                    "offset": 0
                                },
                                {
                                    "value": 5,
                                    "label": {
                                        "text": "Orange"
                                    },
                                    "color": "auto",
                                    "offset": 0
                                }
                            ]
                        }
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "chart_pie",
        icon: "chart_pie",
        title: "Pie Chart",
        description: "Communicate the distribution of data. Most meaningful when paired with absolute values.",
        category: "data",
        tags: "column donut chart category chart compete competitors competitor competition survey poll results business percent percentage better worse faster slower better worse faster slower more less higher lower total sum part number share market share compare vs comparison relationship results business size"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "GanttChart",

        defaultData: {
            primary: {
                showGrid: true,
                showTaskDetail: "duration",
                items: [
                    {
                        startDate: Date.UTC(new Date().getFullYear(), 0, 1),
                        endDate: Date.UTC(new Date().getFullYear(), 0, 31, 23, 59, 59, 999),
                        label: ""
                    }
                ],
                isNormalized: true,
                milestones: []
            }
        },

        allowColorfulBackrounds: false,

    }), getStaticProps: () => ({
        id: "gantt_chart",
        icon: "gantt_chart",
        title: "Gantt Chart",
        description: "Depict hierarchy, sequence, and duration with relative or absolute timeframes.",
        category: "data",
        tags: "time task date end start process management people dependency schedule duration activity project status plan planning timeline coordinate track progress month quarter week year manager parallel dependencies"
    })
});

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// COMPARE TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "CompareBubble",
        variations: "compare",

        allowColorful: true,

        defaultData: {
            "primary": {
                "minValue": 0,
                "maxValue": 100,
                "scaling": "linear",
                "items": [
                    {
                        "value": 10,
                        "title": ""
                    },
                    {
                        "value": 100,
                        "title": ""
                    },
                    {
                        "value": 50,
                        "title": ""
                    }
                ]
            }
        },
    }), getStaticProps: () => ({
        id: "compare_circles",
        icon: "compare_circles",
        title: "Compare Circles",
        description: "Distinguish between the volume or outcome of two or more competing items.",
        category: "comparisons",
        tags: "line column emtric pie chart donut chart burn price pricing goal OKR compare vs ratio size market change time category categories bubble bubbles circle circles difference different unique compete competitors competitor competition grow growing growth projections data shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown survey poll results business percent percentage revenue metrics business profit sales business income volume expenses costs progress better worse faster slower more less higher lower over time market share churn retention make a head-to-head comparison relationship stat statistic infographic"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "CompareRadialBar",
        variations: "compare",

        allowColorful: true,

        defaultData: {
            "primary": {
                "minValue": 0,
                "maxValue": 100,
                "scaling": "linear",
                "items": [
                    {
                        "value": 25,
                        "title": ""
                    },
                    {
                        "value": 75,
                        "title": ""
                    },
                    {
                        "value": 100,
                        "title": ""
                    }
                ]
            }
        },
    }), getStaticProps: () => ({
        id: "compare_radial_bars",
        icon: "compare_radial_bars",
        title: "Compare Radial Bars",
        description: "Compare progress or outcomes across items with a shared objective.",
        category: "comparisons",
        tags: "column pie chart donut chart goal OKR chart compare vs infographic change compete competitors competitor competition grow growing data shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown poll business percent percentage progress better worse faster slower more less higher lower metrics performance business performance business over time churn retention make a head-to-head comparison relationship market share stat statistic growth projections categories infographic"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "CompareVerticalBar",

        variations: "compare",

        allowColorful: true,

        defaultData: {
            "primary": {
                "minValue": 0,
                "maxValue": 100,
                "scaling": "linear",
                "items": [
                    {
                        "value": 25,
                        "title": ""
                    },
                    {
                        "value": 75,
                        "title": ""
                    },
                    {
                        "value": 100,
                        "title": ""
                    }
                ]
            }
        },
    }), getStaticProps: () => ({
        id: "compare_vertical_bars",
        icon: "compare_vertical_bars",
        title: "Compare Columns",
        description: "Distinguish between the volume or outcome of two or more competing items.",
        category: "comparisons",
        tags: "line pie chart donut chart price pricing goal OKR market share chart compare vs bar change category categories difference different unique compete competitors competitor competition grow growing growth projections data shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown survey poll results business revenue metrics business business profit sales income volume expenses costs progress better worse faster slower more less higher lower over churn retention make a head-to-head comparison relationship stat statistic size infographic"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "CompareHorizontalBar",

        variations: "compare",

        allowColorful: true,

        defaultData: {
            "primary": {
                "minValue": 0,
                "maxValue": 100,
                "scaling": "linear",
                "items": [
                    {
                        "value": 25,
                        "title": ""
                    },
                    {
                        "value": 75,
                        "title": ""
                    },
                    {
                        "value": 100,
                        "title": ""
                    }
                ]
            }
        },
    }), getStaticProps: () => ({
        id: "compare_horizontal_bars",
        icon: "compare_horizontal_bars",
        title: "Compare Bars",
        description: "Distinguish between the volume or outcome of two or more competing items.",
        category: "comparisons",
        tags: "line pie chart donut chart price pricing goal OKR market share chart compare vs bar change time category categories difference different unique compete competitors competitor competition grow growing growth projections data shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown survey poll results business revenue metrics business business profit sales income volume expenses costs progress better worse faster slower more less higher lower over churn retention make a head-to-head comparison relationship stat statistic size infographic"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "CompareVerticalPictograph",

        variations: "compare",

        allowColorful: true,

        defaultData: {
            "primary": {
                "minValue": 0,
                "maxValue": 100,
                "scaling": "linear",
                "showValue": true,
                "items": [
                    {
                        "value": 50,
                        "title": ""
                    },
                    {
                        "value": 75,
                        "title": ""
                    },
                    {
                        "value": 100,
                        "title": ""
                    }
                ]
            }
        },
    }), getStaticProps: () => ({
        id: "compare_vertical_pictograph",
        icon: "compare_vertical_pictograph",
        title: "Percentage Comparison",
        description: "Distinguish between the progress toward a shared goal of two or more competing items.",
        category: "comparisons",
        tags: "column pie chart donut chart goal OKR compare vs change time icons categories difference different unique compete competitors competitor competition grow growing growth projections data shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown survey poll results business progress better worse faster slower more less higher lower churn retention make a head-to-head comparison relationship data over time stat statistic infographic"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "SliceChart",

        allowColorBackgrounds: true,
        allowColorful: true,
        defaultData: {
            "primary": {
                "items": [
                    {
                        "width": 1
                    },
                    {
                        "width": 1
                    },
                    {
                        "width": 2
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "slicechart",
        icon: "slicechart",
        title: "Compare Slices",
        description: "Show the relative relationship between the parts of a whole.",
        category: "comparisons",
        tags: "compete competitors competitor competition partner partners user users targets pipeline case study landscape infographic"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "ProcessDiagramChevrons",

        variations: "process",

        allowColorful: true,
        defaultData: {
            "primary": {
                "backgroundColor": "theme",
                "gradiateColors": true,
                "items": [
                    {
                        "title": "Step #1"
                    },
                    {
                        "title": "Step #2"
                    },
                    {
                        "title": "Step #3"
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "step_chevrons",
        icon: "step_chevrons",
        title: "Process Diagram",
        description: "Show the sequence of steps that contribute to an objective.",
        category: "diagram",
        tags: "pipeline procedure schedule lifecycle protocol sequence event evolution objective goal OKR OKR process diagram flow chevron chevrons steps step agenda schedule timeline progress over time project schedule update infographic"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "ProcessDiagramBoxes",

        variations: "process",

        allowColorful: true,

        defaultData: {
            "primary": {
                "backgroundColor": "theme",
                "gradiateColors": true,
                "items": [
                    {
                        "title": "Step #1",
                        "content_value": ""
                    },
                    {
                        "title": "Step #2",
                        "content_value": ""
                    },
                    {
                        "title": "Step #3",
                        "content_value": ""
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "step_boxes",
        icon: "step_boxes",
        title: "Numbered Boxes",
        description: "Arrange concepts, steps, or tasks in sequential, contained boxes.",
        category: "diagram",
        tags: "pipeline procedure schedule lifecycle protocol sequence event evolution process objective goal OKR process flow diagram steps schedule agenda steps time timeline project schedule update number numbered objective goal OKR process diagram flow box message messages agenda compete competitors competitor competition values share our vision feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions schedule accomplish accomplishments accomplished key takeaway highlight priority"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "IconCircle",

        variations: "nodes",

        allowColorful: true,
        defaultData: {
            primary: {
                ellipse_size: 1,
                show_arrows: true,
                clockwise: true,
                shape_is_polygon: false,
                items: [
                    {
                        content_type: "icon",
                        content_value: "",
                        title: "Item #1",
                        nodeType: NodeType.CONTENT_AND_TEXT
                    },
                    {
                        content_type: "icon",
                        content_value: "",
                        title: "Item #2",
                        nodeType: NodeType.CONTENT_AND_TEXT
                    },
                    {
                        content_type: "icon",
                        content_value: "",
                        title: "Item #3",
                        nodeType: NodeType.CONTENT_AND_TEXT
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "step_circular",
        icon: "step_circular",
        title: "Cycle",
        description: "Represent a continuous process with no end point.",
        category: "diagram",
        tags: "procedure schedule wheel lifecycle protocol sequence event evolution process diagram flow circle circular round looping virtuous vicious circle cycle repeat repeating round around time network effects infographic"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "HubAndSpoke",

        variations: "nodes",

        allowColorful: true,
        defaultData: {
            primary: {
                ellipse_size: 1.15,
                useAlternateRotation: true,
                items: [
                    {
                        title: "Item #1",
                        nodeType: NodeType.CONTENT_AND_TEXT
                    },
                    {
                        title: "Item #2",
                        nodeType: NodeType.CONTENT_AND_TEXT
                    },
                    {
                        title: "Item #3",
                        nodeType: NodeType.CONTENT_AND_TEXT
                    },
                    {
                        title: "Item #4",
                        nodeType: NodeType.CONTENT_AND_TEXT
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "hub_and_spoke",
        icon: "hub_and_spoke",
        title: "Hub and Spoke",
        description: "Illustrate divergence or convergence with a central core.",
        category: "diagram",
        tags: "network relationship connect connection hub spoke diagram universe solar system constellation molecule molecular tree planet circle bubble mindmap mind map brainstorm distribution distribute model structure organization org piece Components core universe center"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "NodeDiagram",

        allowColorful: true,
        allowCallouts: false,
        defaultData: {
            primary: {
                snapToGrid: false,
                showGrid: false,
                items: [
                    {
                        x: 0.5,
                        y: 0.5,
                        nodeType: NodeType.BOX
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "flow_chart",
        icon: "flow_chart",
        title: "Flow Chart",
        description: "Illustrate abstract concepts, decision points, and relationships with a multidirectional flow.",
        category: "diagram",
        tags: "flow diagram process decision path branch branching outline node network relationship connect connection hub spoke diagram mindmap mind map brainstorm distribution distribute model structure organization org"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Timeline",

        availableTrayLayouts: [],
        availableHeaderPositions: [HeaderPositionType.TOP],

        allowColorful: true,

        variations: "timeline",

        defaultData: {
            primary: {
                fit: false,
                showContent: false,
                scale: 1,
                scroll: 0,
                showStartMarker: true,
                showEndMarker: true,
                startMarker: {
                    start_marker: { text: "Start" }
                },
                endMarker: {
                    end_marker: { text: "End" }
                },
                items: [
                    {
                        body: "",
                        title: "",
                        x: 0.25,
                        type: "milestone"
                    },
                    {
                        body: "",
                        title: "",
                        x: 0.5,
                        type: "milestone"
                    },
                    {
                        body: "",
                        title: "",
                        x: 0.75,
                        type: "milestone"
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "timeline",
        icon: "timeline",
        title: "Timeline",
        description: "Communicate the distribution and sequence of events within a defined period.",
        category: "diagram popular",
        tags: "status procedure schedule experience background personal education event traction objective goal OKR time timeline duration date milestone milestones agenda history past present future progress accomplish accomplishments accomplished case study over time process"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Journey",

        availableTrayLayouts: [],
        availableHeaderPositions: [HeaderPositionType.TOP],
        allowElementTextInline: true,
        allowElementTextTray: true,
        allowElementAttribution: true,

        allowColorful: true,

        variations: "timeline",

        defaultData: {
            primary: {
                fit: false,
                scale: 1,
                scroll: 0,
                showStartMarker: false,
                showEndMarker: false,
                startMarker: {
                    start_marker: null,
                },
                endMarker: {
                    end_marker: null,
                },
                items: [
                    {
                        body: "",
                        title: "",
                    },
                    {
                        body: "",
                        title: "",
                    },
                    {
                        body: "",
                        title: "",
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "journey",
        icon: "journey",
        title: "Journey",
        description: "Communicate the sequence of events over an abstract period of time.",
        category: "diagram",
        tags: "status procedure schedule experience background personal education event traction objective goal OKR time timeline duration date milestone milestones agenda history past present future progress accomplish accomplishments accomplished case study over time process path journey road trail meander",
    })
});

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// PEOPLE TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "ContactInfo",
        version: 8,

        allowHeader: false,
        allowElementTextInline: false,
        allowElementTextTray: false,
        allowElementAttribution: false,
        allowFooter: true,
        preventDefaultFooter: true,

        availableTrayLayouts: [],

        defaultBackgroundStyle: "backgroundDark",
        allowColorful: true,

        defaultData: {
            primary: {
                layout: "left_map",
                map_address: {
                    "text": DEFAULT_ADDRESS,
                },
                showMarker: true,
                items: [
                    {
                        type: "contact_header",
                        text: "Contact Us"
                    },
                    {
                        type: "address",
                    },
                    {
                        type: "phone",
                        content_value: ""
                    },
                    {
                        type: "social",
                        social_type: "twitter",
                        content_value: ""
                    }
                ]
            }
        },
    }), getStaticProps: () => ({
        id: "contactus",
        icon: "contact_info",
        title: "Contact Us",
        description: "Let people know where to find you and how to get in touch.",
        category: "organization",
        tags: "map place location office org organization contact address location phone email twitter instagram linkedin facebook company business team about us share my contact info"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "TextSlide",

        showHeader: true,

        defaultData: {
            layout: {
                trayLayout: TrayType.LEFT_TRAY,
            },
            tray: {
                trayWidth: 567,
                items: [{ id: "" }]
            },
            primary: {
                text: {
                    text: ""
                }
            }
        },

        allowColorful: true,
    }), getStaticProps: () => ({
        id: "long_bio",
        icon: "long_bio",
        title: "Long Bio",
        description: "A free space to write a longer biography of yourself.",
        category: "people",
        tags: "speaker about me experience background personal education person bio contact speaker presenter about me phone email twitter instagram linkedin facebook photo photos photographs images pictures portrait headshot share my contact info intros team"

    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "LogoGrid",

        availableTrayLayouts: [],

        allowColorful: false,

        defaultData: {
            primary: {
                showFrame: true,
                items: [
                    {
                        content_type: "logo",
                        content_value: ""
                    },
                    {
                        content_type: "logo",
                        content_value: ""
                    },
                    {
                        content_type: "logo",
                        content_value: ""
                    },
                    {
                        content_type: "logo",
                        content_value: ""
                    },
                    {
                        content_type: "logo",
                        content_value: ""
                    },
                    {
                        content_type: "logo",
                        content_value: ""
                    }
                ]
            }
        }

    }), getStaticProps: () => ({
        id: "logogrid",
        icon: "logogrid",
        title: "Logo Grid",
        description: "Reflect a customer or partner ecosystem by putting their logos on display.",
        category: "product",
        tags: "status pipeline press pr partners partnerships logo logos marketing sales customer customers compete competitors competitor competition partner partners user users targets pipeline case study landscape"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Team",

        allowColorful: false,

        defaultData: {
            "primary": {
                "items": [
                    {
                        "content_type": "image",
                        "content_value": ""
                    },
                    {
                        "content_type": "image",
                        "content_value": ""
                    },
                    {
                        "content_type": "image",
                        "content_value": ""
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "team",
        icon: "team",
        title: "Team Members",
        description: "Introduce yourself or key team members to your audience.",
        category: "people popular",
        tags: "team photos company business presenter presenters lineup speaker speakers org organization company business people teammates employees headshot photo photos photographs images pictures portrait list intros org structure bios"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "OrgChart",

        defaultData: {
            primary: {
                defaultNodeStyle: "box",
                hideRootNode: false,
                layout: "expanded",
                layoutDirection: "vertical",
                items: [{
                    id: "0",
                    index: 0,
                    nodeType: "person",
                    title: {
                        text: ""
                    },
                    body: {
                        text: ""
                    }
                }, {
                    id: "1",
                    index: 0,
                    nodeType: "person",
                    parent: "0",
                    title: {
                        text: ""
                    },
                    body: {
                        text: ""
                    }
                }, {
                    id: "2",
                    index: 1,
                    nodeType: "person",
                    parent: "0",
                    title: {
                        text: ""
                    },
                    body: {
                        text: ""
                    }
                }, {
                    id: "3",
                    index: 0,
                    nodeType: "person",
                    parent: "2",
                    title: {
                        text: ""
                    },
                    body: {
                        text: ""
                    }
                }, {
                    id: "4",
                    index: 1,
                    nodeType: "person",
                    parent: "2",
                    title: {
                        text: ""
                    },
                    body: {
                        text: ""
                    }
                }]
            }
        }

    }), getStaticProps: () => ({
        id: "orgchart",
        icon: "org_chart",
        title: "Org Chart",
        description: "Visualize the structure of a team, company, or organization.",
        category: "people",
        tags: "org structure organization company business team people hierarchy",
    })
});

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// VIDEO TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "Video",

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE,
                showFooter: "off",
            },
            primary: {
                fullBleed: true,
                autoPlay: true,
                startTime: 0
            }
        },

        allowHeader: true,
        allowFooter: true,

        canConvertToAuthoring: false,

        allowColorful: false,
    }), getStaticProps: () => ({
        id: "video",
        icon: "video",
        title: "Video",
        category: "impact",
        tags: "video movie clip mp4 mov",
        description: "Use video to reinforce your story."
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "TableFrame",

        allowColorBackgrounds: false,
        allowColorful: false,

        defaultData: {
            primary: {
                tableWidth: 1,
                tableHeight: 0.4,
                showTopLeftCell: true,
                showBorder: true,
                showColGridLines: true,
                showRowGridLines: true,
                showHeaderRow: true,
                showHeaderCol: true,
                cols: [
                    {
                        index: 0,
                        style: "headerCol",
                        break: false,
                        size: 50
                    },
                    {
                        index: 1,
                        style: "defaultCol",
                        break: false,
                        size: 60
                    },
                    {
                        index: 2,
                        style: "defaultCol",
                        break: false,
                        size: 60
                    },
                    {
                        index: 3,
                        style: "defaultCol",
                        break: false,
                        size: 60
                    },
                    {
                        index: 4,
                        style: "defaultCol",
                        break: false,
                        size: 60
                    }
                ],
                rows: [
                    {
                        index: 0,
                        style: "headerRow",
                        break: false,
                        size: 40
                    },
                    {
                        index: 1,
                        style: "defaultRow",
                        break: false,
                        size: 30
                    },
                    {
                        index: 2,
                        style: "defaultRow",
                        break: false,
                        size: 30
                    },
                    {
                        index: 3,
                        style: "defaultRow",
                        break: false,
                        size: 30
                    }
                ],
                cells: [
                    {
                        "row": 0,
                        "col": 0,
                    },
                    {
                        "row": 0,
                        "col": 1,
                    },
                    {
                        "row": 0,
                        "col": 2,
                    },
                    {
                        "row": 0,
                        "col": 3,
                    },
                    {
                        "row": 0,
                        "col": 4,
                    },
                    {
                        "row": 1,
                        "col": 0,
                    },
                    {
                        "row": 1,
                        "col": 1,
                    },
                    {
                        "row": 1,
                        "col": 2,
                    },
                    {
                        "row": 1,
                        "col": 3,
                    },
                    {
                        "row": 1,
                        "col": 4,
                    },
                    {
                        "row": 2,
                        "col": 0,
                    },
                    {
                        "row": 2,
                        "col": 1,
                    },
                    {
                        "row": 2,
                        "col": 2,
                    },
                    {
                        "row": 2,
                        "col": 3,
                    },
                    {
                        "row": 2,
                        "col": 4,
                    },
                    {
                        "row": 3,
                        "col": 0,
                    },
                    {
                        "row": 3,
                        "col": 1,
                    },
                    {
                        "row": 3,
                        "col": 2,
                    },
                    {
                        "row": 3,
                        "col": 3,
                    },
                    {
                        "row": 3,
                        "col": 4,
                    }
                ]
            }
        }

    }), getStaticProps: () => ({
        id: "table-v2",
        icon: "table",
        title: "Table",
        description: "Organize your data into columns and rows to present information, categorize ideas, or compare items.",
        category: "basic popular",
        tags: "traction objective goal OKR market share feature features product benefit benefits business differentiate project differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions percent percentage revenue metrics business profit sales income volume expenses costs summary summarize accomplish accomplishments accomplished make a list amount total sum churn metrics financial model compare vs by categories results business update status relationship",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "SlidePlaceholder",

        allowHeader: false,
        allowFooter: false,
        allowElementTextInline: false,
        allowElementTextTray: false,
        allowElementAttribution: false,

        availableTrayLayouts: [],

        canConvertToAuthoring: false,

    }), getStaticProps: () => ({
        id: "slidePlaceholder",
        icon: "placeholder",
        title: "Slide Placeholder",
        description: "Not sure which template to choose yet? Don't worry, we'll hold your spot.",
        category: "organization",
        tags: "place placeholder tbd scratch pad scratchpad blank slide",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "StackDiagram",

        allowColorBackgrounds: true,
        allowColorful: false,

        variations: "stackdiagram",

        defaultData: {
            primary: {
                cols: 12,
                rows: 12,
                items: [{
                    x: 0, y: 0, width: 12, height: 3, showText: true,
                }, {
                    x: 0, y: 3, width: 3, height: 6, showText: true,
                }, {
                    x: 3, y: 3, width: 3, height: 6, showText: true,
                }, {
                    x: 6, y: 3, width: 3, height: 6, showText: true,
                }, {
                    x: 9, y: 3, width: 3, height: 6, showText: true,
                }, {
                    x: 0, y: 9, width: 12, height: 3, showText: true,
                }]
            }
        }
    }), getStaticProps: () => ({
        id: "stackDiagram",
        icon: "stack_hierarchy",
        title: "Stack Diagram",
        description: "Communicate relationship, hierarchy, and distribution through stacked layers.",
        category: "diagram",
        tags: "stack structure organization order relationship software architecture services layer group flow diagram platform base system foundation box boxes",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "UserTestimonial",

        allowColorful: true,

        defaultData: {
            primary: {
                showTail: true,
                showDesignQuotes: true,
                frameStyle: "quote-box",
                items: [
                    {
                        quote: "",
                        showAttribution: true,
                        showImage: true,
                        showLogo: false
                    },
                    {
                        quote: "",
                        showAttribution: true,
                        showImage: true,
                        showLogo: false
                    }
                ]
            }
        },
    }), getStaticProps: () => ({
        id: "user_testimonial",
        icon: "user_testimonial",
        title: "Quotes",
        description: "Use industry, customer, or leadership quotes to communicate ideas or feedback.",
        category: "people",
        tags: "users user testimonial persona partners partnerships pr press customers problem speaker intros team culture members compete competitors competitor competition messages message make a list items category categories reasons values share our vision feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions summary summarize accomplish accomplishments accomplished photo photos photographs images pictures services solution key takeaway highlight priority bullet update status points case study landscape call to action image text product features",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Calendar",

        variations: "calendar",
        allowColorBackgrounds: true,

        defaultData: {
            primary: {
                showTitle: false,
                showWeekends: true,
                startOnMonday: false,
                calendarType: "month",
                date: moment().startOf("week").format("MM/DD/YYYY")
            }
        }

    }), getStaticProps: () => ({
        id: "calendar-month",
        icon: "calendar_month",
        title: "Calendar - Month",
        description: "Display temporal events or projects over a calendar month.",
        category: "diagram",
        tags: "calendar date week month time day days year tasks schedule events when",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Calendar",

        variations: "calendar",
        allowColorBackgrounds: true,

        defaultData: {
            primary: {
                showTitle: false,
                showWeekends: true,
                startOnMonday: false,
                calendarType: "week",
                date: moment().startOf("week").format("MM/DD/YYYY")
            }
        }

    }), getStaticProps: () => ({
        id: "calendar-week",
        icon: "calendar_week",
        title: "Calendar - Week",
        description: "Display temporal events or projects over a calendar week.",
        category: "diagram",
        tags: "calendar date week month time day days year tasks schedule events when",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "VerticalTaskLists",

        allowColorBackgrounds: false,

        variations: "tasklist",

        defaultData: {
            primary: {
                items: [{
                    label: "To do",
                    items: [{
                        title: "Task 1"
                    }, {
                        title: "Task 2",
                        color: "accent1",
                        icon: "star"
                    }]
                }, {
                    label: "In progress",
                    items: [{
                        title: "Task 3"
                    }, {
                        title: "Task 4"
                    }]
                }, {
                    label: "Completed",
                    items: [{
                        title: "Task 5",
                        color: "accent1",
                        icon: "star"
                    }]
                }]
            }
        }

    }), getStaticProps: () => ({
        id: "kanban",
        icon: "kanban",
        title: "Kanban Board",
        description: "Cluster lists into enclosed vertical containers to communicate tasks, progress, hierarchy, and responsibiliity.",
        category: "diagram",
        tags: "kanban project board cards columns tasks progress swimlane team work organize flow process",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "HorizontalTaskLists",

        allowColorBackgrounds: false,

        variations: "tasklist",

        defaultData: {
            primary: {
                items: [{
                    label: "To do",
                    items: [{
                    }, {
                    }]
                }, {
                    label: "In progress",
                    items: [{
                    }, {
                    }]
                }, {
                    label: "Completed",
                    items: [{
                    }]
                }]
            }
        }

    }), getStaticProps: () => ({
        id: "horizontal-task-list",
        icon: "horizontal-task-list",
        title: "Horizontal Task List",
        description: "Cluster lists into enclosed horizontal containers to communicate tasks, progress, hierarchy, and responsibiliity.",
        category: "diagram",
        tags: "kanban project board cards columns tasks progress swimlane team work organize flow process",
    })
});

/// HIDDEN TEMPLATES ------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "TextList",

        showHeader: true,
        showFooter: false,
        allowElementAttribution: true,

        defaultData: {
            layout: {
                trayLayout: TrayType.LEFT_INLINE,
            },
            tray: {
                // trayElement: "Image",
                trayWidth: 470,
                items: [{ id: "" }]
            },
            primary: {
                forceSingleColumn: true,
                items: [{ id: "" }]
            }
        },

        allowColorful: true,

    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "bullets_image",
        icon: "bullets_image",
        title: "List with an Image",
        description: "Pair your bullet points with an inline image to give them equal weight.",
        category: "basic",
        tags: "bullet update status points text message messages values share our vision feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions summary summarize accomplish accomplishments accomplished make a list services solution key takeaway highlight priority case study product features"
    })
});
templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoCollage",

        availableTrayLayouts: [],

        allowElementAttribution: false,

        allowFooter: true,
        preventDefaultFooter: true,
        allowColorful: true,
        allowColorBackgrounds: false,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE
            },
            primary: {
                showGutter: true,
                fullBleed: true,
                matchTextScale: true,
                items: [{ id: uuid() }, { id: uuid() }],
                layoutType: "grid",
            }
        }
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "picture_picture",
        icon: "picture_picture",
        title: "Two Images",
        description: "Place two images side-by-side to make a comparison or a statement.",
        category: "impact",
        tags: "pro con picture image photo photos photographs images pictures emotional inspire audience inspiration emotion impact feelings compare vs comparison relationship"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoCollage",

        allowElementAttribution: false,

        availableTrayLayouts: [],

        allowColorful: true,
        allowColorBackgrounds: false,

        defaultData: {
            primary: {
                showGutter: true,
                fullBleed: false,
                matchTextScale: true,
                items: [
                    {
                        x: 0,
                        y: 0,
                        width: 3,
                        height: 4,
                    },
                    {
                        x: 3,
                        y: 0,
                        width: 3,
                        height: 2,
                    },
                    {
                        x: 3,
                        y: 2,
                        width: 3,
                        height: 2,
                    }
                ],
                cols: 6,
                rows: 4
            }
        }
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "imagegrid",
        icon: "imagegrid",
        title: "Photo Grid with Header",
        description: "Place images and headline text in a flexible and customizable grid.",
        category: "basic",
        tags: ""
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoCollage",

        availableTrayLayouts: [],

        allowFooter: true,
        preventDefaultFooter: true,
        allowHeader: false,
        allowElementTextInline: true,
        allowElementTextTray: true,
        allowElementAttribution: true,

        defaultData: {
            primary: {
                blocks: [{
                    type: "headline"
                }],
                items: [],
                layoutType: "grid",
                fullBleed: true,
                showGutter: true
            }
        },
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "headline",
        icon: "headline",
        title: "Headline",
        description: "Bold text placed over a beautiful image. Just like your favorite Nike ad.",
        category: "impact popular",
        tags: "thank big segue transition share our mission provocative question call to action vision differentiate differentiator proposition propositions powerful bold summary summarize message statement accomplish accomplishments accomplished photo photos photographs images pictures emotional inspire audience inspiration emotion impact feelings key takeaway highlight big headline and culture text"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoCollage",

        availableTrayLayouts: [],

        allowFooter: true,
        preventDefaultFooter: true,
        allowHeader: false,
        allowElementTextInline: true,
        allowElementTextTray: true,
        allowElementAttribution: true,

        defaultData: {
            primary: {
                blocks: [
                    {
                        type: "label",
                        content: {
                            text: "Section 1",
                            styles: [
                                {
                                    start: 0,
                                    end: 9
                                }
                            ]
                        }
                    },
                    {
                        type: "headline"
                    }
                ],
                items: [],
                layoutType: "grid",
                fullBleed: true,
                showGutter: true
            },
            layout: {
                backgroundColor: "theme",
                backgroundStyle: "backgroundColor"
            }
        },

        version: 2,
    }), getStaticProps: () => ({
        id: "chapter",
        hideTemplate: true,
        icon: "section_break",
        title: "Section Break",
        description: "Moving on to another section of your presentation? Let your audience know.",
        category: "organization",
        tags: "question introduction introduce chapter section transition segue transition header"

    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoCollage",
        version: 2,

        allowHeader: false,
        allowFooter: true,
        preventDefaultFooter: true,
        allowElementTextInline: true,
        allowElementTextTray: true,
        allowElementAttribution: true,

        defaultBackgroundStyle: "backgroundLight",
        allowColorful: true,

        defaultData: {
            layout: {},
            primary: {
                items: [
                    {
                        cellColor: "theme"
                    },
                    {
                        cellColor: "theme",
                        showText: true,
                        blocks: [
                            {
                                type: "headline"
                            }
                        ]
                    }
                ],
                dividerSize: 0.5,
                aspectRatio: "fill",
                showGutter: true,
                layoutType: "grid",
                frame: "none",
                fullBleed: true
            }
        }

    }), getStaticProps: () => ({
        id: "picture_headline_right",
        hideTemplate: true,
        icon: "picture_headline_right",
        title: "Big Message with an Image",
        description: "A powerful image and message placed side-by-side. A presentation classic.",
        category: "impact",
        tags: "experience background personal education person thank logo problem big headline share our mission provocative question call to action vision differentiate differentiator proposition propositions powerful bold summary summarize statement accomplish accomplishments accomplished photo photos photographs images pictures message services solution emotional inspire audience inspiration emotion impact feelings big text"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoCollage",

        allowElementTitle: true,
        allowAttribution: false,

        availableTrayLayouts: [],

        allowFooter: true,
        preventDefaultFooter: true,
        allowColorful: true,
        allowColorBackgrounds: false,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE
            },
            primary: {
                showGutter: true,
                fullBleed: true,
                items: [{
                    showText: true,
                    blocks: [{ type: "headline" }]
                }, {
                    showText: true,
                    blocks: [{ type: "headline" }]
                }]
            }
        },

    }), getStaticProps: () => ({
        id: "text_text",
        hideTemplate: true,
        icon: "text_text",
        title: "Two Messages",
        description: "Place two headlines side-by-side to create space between messages.",
        category: "impact",
        tags: "pro con emotional inspire audience inspiration emotion impact feelings compare vs comparison relationship two messages key headlines"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoCollage",

        allowElementAttribution: false,

        availableTrayLayouts: [],

        allowFooter: true,
        preventDefaultFooter: true,
        allowColorful: true,
        allowColorBackgrounds: false,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE
            },
            primary: {
                showHeadline: false,
                showImages: true,
                layoutType: "grid",
                aspectRatio: "fill",
                showGutter: true,
                fullBleed: true,
                matchTextScale: true,
                items: [
                    {
                        cellColor: "theme",
                        showText: true,
                        blocks: [
                            {
                                type: "headline",
                            }
                        ]
                    },
                    {
                        cellColor: "theme"
                    },
                    {
                        cellColor: "theme"
                    },
                    {
                        cellColor: "theme"
                    },
                    {
                        cellColor: "theme"
                    }
                ],
                "cols": 4,
                "rows": 2,
                "gridLayout": "7"
            }
        }

    }), getStaticProps: () => ({
        id: "culturegrid",
        hideTemplate: true,
        icon: "culture_grid",
        title: "About Us",
        description: "Briefly describe your organization and show your team in action.",
        category: "people",
        tags: "about us org team culture share our mission vision company business organization values vision photo photos photographs images pictures collage emotional inspire audience inspiration emotion impact feelings teammate bio"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Headline",

        allowHeader: false,
        allowFooter: true,
        preventDefaultFooter: true,
        allowElementTextInline: true,
        allowElementTextTray: true,
        allowElementAttribution: true,

        availableTrayLayouts: [],

        defaultBackgroundStyle: "backgroundLight",
        allowColorful: true,

        defaultData: {
            layout: {},
            primary: {
                blocks: [{ type: "headline" }],
                items: [{ id: uuid() }],
                dividerSize: 0.5,
                aspectRatio: "fill",
                showGutter: false,
                layoutType: "grid",
                frame: "none",
                fullBleed: false,
                headlinePosition: "left"
            }
        }

    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "headline_image",
        icon: "headline_with_image",
        title: "Headline and image",
        description: "A powerful image and message placed side-by-side. A presentation classic.",
        category: "impact",
        tags: "experience background personal education person thank logo problem big headline share our mission provocative question call to action vision differentiate differentiator proposition propositions powerful bold summary summarize statement accomplish accomplishments accomplished photo photos photographs images pictures message services solution emotional inspire audience inspiration emotion impact feelings big text"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Headline",

        allowElementAttribution: false,

        availableTrayLayouts: [],

        allowFooter: true,
        preventDefaultFooter: true,
        allowColorful: true,
        allowColorBackgrounds: false,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE
            },
            primary: {
                aspectRatio: "fill",
                fullBleed: true,
                gridLayout: "0",
                headlinePosition: "left",
                items: [{ id: uuid() }, { id: uuid() }, { id: uuid() }, { id: uuid() }],
                showGutter: true,
                showImages: true
            }
        }

    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "aboutUs",
        icon: "culture_grid",
        title: "About Us",
        description: "Briefly describe your organization and show your team in action.",
        category: "people",
        tags: "about us org team culture share our mission vision company business organization values vision photo photos photographs images pictures collage emotional inspire audience inspiration emotion impact feelings teammate bio"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "ProductScreenshot",
        defaultData: {
            "primary": {
                "content_type": "image",
                "content_value": "",
                "showCallout": true,
                "listStyle": "bullets",
                "items": [
                    {
                        "content_type": "icon",
                        "title": "",
                        "body": "",
                        "calloutTargetX": 0.25,
                        "calloutTargetY": 0.25,
                        "content_value": ""
                    }
                ],
                "frameType": "iphone_x"
            }
        },

        availableTrayLayouts: [],
        allowColorful: true,

    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "product_mobile",
        icon: "product_mobile",
        title: "Mobile Screenshot",
        description: "Call out product features on just about any device\u2014we've got 'em all.",
        category: "product",
        tags: "display product laptop desktop screenshot callouts features monitor screen shots pc device callout features mobile phone iphone android device mac feature features benefit benefits annotation differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions photo photos photographs images pictures demo"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "ProductScreenshot",
        defaultData: {
            "primary": {
                "content_type": "image",
                "content_value": "",
                "showCallout": true,
                "listStyle": "bullets",
                "items": [
                    {
                        "content_type": "icon",
                        "title": "",
                        "body": "",
                        "calloutTargetX": 0.25,
                        "calloutTargetY": 0.25,
                        "content_value": ""
                    }
                ],
                "frame": "apple_thunderbolt_display"
            }
        },

        availableTrayLayouts: [],

        allowColorful: true,

    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "product_desktop",
        icon: "product_desktop",
        title: "Desktop Screenshot",
        description: "Call out product features on just about any device\u2014we've got 'em all.",
        category: "product",
        tags: "product laptop desktop screenshot callouts features monitor screen shots pc device callout features mobile phone iphone android device mac feature features benefit benefits annotation differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions photo photos photographs images pictures demo"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "XYGraph",

        variations: "xygraph",

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            primary: {
                yAxisLabel: "Size",
                xAxisLabel: "Complexity",
                showArrowHeads: false,
                showAxis: false,
                showAxisLabels: false,
                showQuadrants: true,
                showQuadrantLabels: true,
                showGrid: true,
                gridSize: 34,
                label1: "Challengers",
                label2: "Leaders",
                label3: "Niche Players",
                label4: "Visionaries",
                items: [
                    {
                        x: 0.5,
                        y: 0.5,
                        size: 150,
                        color: "theme",
                        nodeType: NodeType.CIRCLE
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "quadrant",
        icon: "xy_quadrant",
        title: "Quadrants",
        description: "Group items into quadrants to give your audience a lay of the land.",
        category: "comparisons",
        tags: "persona competitive landscape venn xy pro con size group circles bubbles hierarchy set plot scatter scatterplot dimension quadrant axis axes cluster relationship market compare groups us vs them advantages comparison competition competitor relative more less same better worse big small attributes qualities scattergram"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "XYGraph",

        variations: "xygraph",

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            primary: {
                yAxisLabel: "Size",
                xAxisLabel: "Complexity",
                showArrowHeads: false,
                showAxis: false,
                showAxisLabels: false,
                showQuadrants: false,
                showQuadrantLabels: false,
                showGrid: false,
                gridSize: 34,
                label1: "Challengers",
                label2: "Leaders",
                label3: "Niche Players",
                label4: "Visionaries",
                items: [
                    {
                        x: 0.5,
                        y: 0.5,
                        size: 150,
                        color: "theme",
                        nodeType: NodeType.CIRCLE
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "bubbles",
        icon: "bubbles",
        title: "Floating Circles",
        description: "These free-floating circles are great for comparing items by size or location.",
        category: "comparisons",
        tags: "segment segmentation competitive landscape pie chart donut chart growth grow size circles bubbles scatter scatterplot cluster group relationship market compare groups us vs them advantages comparison competition competitor relative more less same better worse big small attributes qualities scattergram"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Pyramid",

        availableHeaderPositions: [HeaderPositionType.TOP],

        variations: "pyramid",

        allowColorful: true,
        defaultData: {
            "primary": {
                "inverted": false,
                "color": "accent1",
                "showDescription": true,
                capSize: 0,
                baseSize: 60,
                "items": [
                    {
                        "title": "Step 1",
                        "body": ""
                    },
                    {
                        "title": "Step 2",
                        "body": ""
                    },
                    {
                        "title": "Step 3",
                        "body": ""
                    }
                ],
                "step": true
            }
        }

    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "pyramid_step",
        icon: "pyramid_step",
        title: "Step Pyramid",
        description: "A variation on the pyramid that can be used to build on a foundation.",
        category: "diagram",
        tags: "foundation pipeline price pricing market size pyramid hierarchy diagram message messages compete competitors competitor competition shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown values feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions percent percentage landscape org structure"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Dashboard",

        // variations: "chart",

        defaultImageTrayType: TrayType.RIGHT_TRAY,

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            "primary": {
                "items": [
                    {
                        "elementType": "chart",
                        "chart": {
                            "showLegend": false,
                            "showXAxis": true,
                            "showYAxis": true,
                            "showAxisLabels": false,
                            "showXGridLines": true,
                            "showYGridLines": true,
                            "groupData": false,
                            "chartData": {
                                "series": [
                                    {
                                        "id": "series1",
                                        "name": "Data",
                                        "type": "spline",
                                        "data": [
                                            {
                                                "y": 10,
                                            },
                                            {
                                                "y": 40,
                                            },
                                            {
                                                "y": 50,
                                            },
                                            {
                                                "y": 30,
                                            },
                                            {
                                                "y": 70,
                                            }
                                        ],
                                        "colorName": "chart1"
                                    }
                                ],
                                "xAxis": {
                                    "visible": true,
                                    "showFirstLabel": true,
                                    "showLastLabel": true,
                                    "endOnTick": true,
                                    "categories": [
                                        "Jan",
                                        "Feb",
                                        "Mar",
                                        "Apr",
                                        "May"
                                    ],
                                    "showAxisLine": true,
                                    "showGridLine": false,
                                    "showMajorTicks": false,
                                    "showMinorTicks": false,
                                    "axisTitle": false,
                                    "axisTitleText": "Title",
                                    "labelInterval": 1,
                                    "type": "linear",
                                    "autoType": "linear",
                                    "categoryType": "auto",
                                    "labels": {
                                        "enabled": true
                                    },
                                    zeroAxisPadding: true
                                },
                                "yAxis": {
                                    "visible": true,
                                    "showFirstLabel": true,
                                    "showLastLabel": true,
                                    "endOnTick": true,
                                    "showAxisLine": true,
                                    "showGridLines": true,
                                    "showMajorTicks": false,
                                    "showMinorTicks": false,
                                    "labelAbbreviation": false,
                                    "labelCurrency": "none",
                                    "labelFormat": "ones",
                                    "axisTitle": "none",
                                    "axisTitleText": "Title",
                                    "labels": {
                                        "enabled": true
                                    }
                                },
                                "yAxis2": {
                                    "visible": false,
                                    "opposite": true,
                                    "showFirstLabel": true,
                                    "showLastLabel": true,
                                    "endOnTick": true,
                                    "showAxisLine": true,
                                    "showGridLines": true,
                                    "showMajorTicks": false,
                                    "showMinorTicks": false,
                                    "labelAbbreviation": false,
                                    "labelCurrency": "none",
                                    "labelFormat": "ones",
                                    "axisTitle": "none",
                                    "axisTitleText": "Title",
                                    "labels": {
                                        "enabled": true
                                    }
                                },
                                "legend": {
                                    "enabled": false
                                }
                            },
                            "legendPosition": "off"
                        }
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "chart_spline",
        icon: "chart_spline",
        title: "Spline Chart",
        description: "These charts smooth out the lines between data points. Snazzy, right?",
        category: "data",
        tags: "column traction chart compete competitors competitor competition grow growing growth projections data shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown revenue metrics performance business profit sales income volume expenses costs progress better worse faster slower better worse faster slower more less higher lower amount total sum number time over churn retention trend"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Dashboard",

        // variations: "chart",

        defaultImageTrayType: TrayType.RIGHT_TRAY,

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            "primary": {
                "items": [
                    {
                        "elementType": "chart",
                        "chart": {
                            "showLegend": false,
                            "showXAxis": true,
                            "showYAxis": true,
                            "showAxisLabels": false,
                            "showXGridLines": true,
                            "showYGridLines": true,
                            "groupData": false,
                            "chartData": {
                                "series": [
                                    {
                                        "id": "series1",
                                        "name": "Data",
                                        "type": "areaspline",
                                        "data": [
                                            {
                                                "y": 10,
                                            },
                                            {
                                                "y": 40,
                                            },
                                            {
                                                "y": 50,
                                            },
                                            {
                                                "y": 30,
                                            },
                                            {
                                                "y": 70,
                                            }
                                        ],
                                        "colorName": "chart1"
                                    }
                                ],
                                "xAxis": {
                                    "visible": true,
                                    "showFirstLabel": true,
                                    "showLastLabel": true,
                                    "endOnTick": true,
                                    "categories": [
                                        "Jan",
                                        "Feb",
                                        "Mar",
                                        "Apr",
                                        "May"
                                    ],
                                    "showAxisLine": true,
                                    "showGridLine": false,
                                    "showMajorTicks": false,
                                    "showMinorTicks": false,
                                    "axisTitle": false,
                                    "axisTitleText": "Title",
                                    "labelInterval": 1,
                                    "type": "linear",
                                    "autoType": "linear",
                                    "categoryType": "auto",
                                    "labels": {
                                        "enabled": true,
                                        "rotation": 0
                                    },
                                    zeroAxisPadding: true
                                },
                                "yAxis": {
                                    "visible": true,
                                    "showFirstLabel": true,
                                    "showLastLabel": true,
                                    "endOnTick": true,
                                    "showAxisLine": true,
                                    "showGridLines": true,
                                    "showMajorTicks": false,
                                    "showMinorTicks": false,
                                    "labelAbbreviation": false,
                                    "labelCurrency": "none",
                                    "labelFormat": "ones",
                                    "axisTitle": "none",
                                    "axisTitleText": "Title",
                                    "labels": {
                                        "enabled": true
                                    }
                                },
                                "yAxis2": {
                                    "visible": false,
                                    "opposite": true,
                                    "showFirstLabel": true,
                                    "showLastLabel": true,
                                    "endOnTick": true,
                                    "showAxisLine": true,
                                    "showGridLines": true,
                                    "showMajorTicks": false,
                                    "showMinorTicks": false,
                                    "labelAbbreviation": false,
                                    "labelCurrency": "none",
                                    "labelFormat": "ones",
                                    "axisTitle": "none",
                                    "axisTitleText": "Title",
                                    "labels": {
                                        "enabled": true
                                    }
                                },
                                "legend": {
                                    "enabled": false
                                }
                            },
                            "legendPosition": "off"
                        }
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "chart_area_spline",
        icon: "chart_area_spline",
        title: "Area Spline Chart",
        description: "An area chart with smooth lines. It's like beautiful, rolling hills of data.",
        category: "data",
        tags: "column curve traction chart compete competitors competitor competition grow growing growth projections data shrink shrinking shrink bigger big large larger small smaller grew shrunk grew shrunk change changed changing grown revenue metrics performance business profit sales income volume expenses costs progress amount total sum number time over churn retention trend stacked"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Dashboard",

        // variations: "chart",

        defaultImageTrayType: TrayType.RIGHT_TRAY,

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            "primary": {
                "items": [
                    {
                        "elementType": "piechart",
                        "piechart": {
                            "isDonut": true,
                            "startRadius": 0,
                            "innerRadius": 0,
                            "labelFormat": "percentage",
                            "sortValues": true,
                            "data": [
                                {
                                    "value": 3,
                                    "label": {
                                        "text": "Apple"
                                    },
                                    "color": "auto",
                                    "offset": 0
                                },
                                {
                                    "value": 2,
                                    "label": {
                                        "text": "Pear"
                                    },
                                    "color": "auto",
                                    "offset": 0
                                },
                                {
                                    "value": 5,
                                    "label": {
                                        "text": "Orange"
                                    },
                                    "color": "auto",
                                    "offset": 0
                                }
                            ]
                        }
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "chart_donut",
        icon: "chart_donut",
        title: "Donut Chart",
        description: "An alternative to pie charts that allows you to put a label in the center.",
        category: "data",
        tags: "column pie chart donut chart market size category chart compete competitors competitor competition survey poll results business percent percentage better worse faster slower better worse faster slower more less higher lower total sum chart number share market part of a whole compare vs comparison relationship results business"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "ContactInfo",

        allowHeader: false,
        defaultBackgroundStyle: "backgroundDark",
        allowElementTextInline: false,
        allowElementTextTray: false,
        allowElementAttribution: false,

        availableTrayLayouts: [],

        allowColorful: true,

        defaultData: {
            "primary": {
                "layout": "left_picture",
                "items": [
                    {
                        "type": "contact_header",
                        "text": "Your Name"
                    },
                    {
                        "type": "text",
                        "text": "Your Title / Position / Company"
                    },
                    {
                        "type": "email",
                        "content_value": ""
                    },
                    {
                        "type": "phone",
                        "social_type": "twitter",
                        "content_value": ""
                    },
                    {
                        "type": "social",
                        "social_type": "twitter",
                        "content_value": ""
                    }
                ]
            }
        }

    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "business_card",
        icon: "business_card",
        title: "Business Card",
        description: "Show your audience who you are and how to reach you after the presentation.",
        category: "people",
        tags: "speaker about me experience background personal education person bio contact speaker presenter about me phone email twitter instagram linkedin facebook photo photos photographs images pictures portrait headshot share my contact info intros team"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Video",

        defaultData: {
            primary: {
                fullBleed: false,
                autoPlay: true,
                startTime: 0
            }
        },

        allowHeader: true,
        allowFooter: true,

        canConvertToAuthoring: false,

        allowColorful: false,
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "video_title",
        icon: "video_title",
        title: "Video with Title",
        category: "impact",
        tags: "video movie clip mov mp4",
        isNew: true
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "WebView",

        canConvertToAuthoring: false,

        defaultData: {
            primary: {
                items: [{

                }]
            }
        }
    }), getStaticProps: () => ({
        id: "web-view",
        icon: "webview",
        title: "WebView",
        description: "Embed URLs for a product demo, your analytics dashboard or to display a live poll!",
        category: "impact",
        tags: "web page url embed iframe external website site http https",
    })
});

module.exports = templates;
